import Request from '../../../../src/core/gd/data/request'

import Moment from 'moment';
import {RequestType} from "../data/types";

export default class ApiAnalytics {

    constructor() {}

    static tasksBurnCompany(companyId: ID, startDate: Moment, endDate: Moment) {
        return new Request(this, RequestType.POST, 'analytics/tasks/burn-company', { // is this ok?
            companyId   : companyId,
            startDate   : Moment(startDate).format("YYYY-MM-DD"),
            endDate     : Moment(endDate).format("YYYY-MM-DD")
        });
    }

    static getTasksProgressSummary(params: any) {
        return new Request(this,'POST','analytics/tasks-progress-summary', params);
    }

    static getTasksProgressSummaryDetails(params: any) {
        return new Request(this,'POST','analytics/tasks-progress-summary-details', params);
    }

    static getTaskSummary(params: any, postfix: string) {
        return new Request(this,'POST','analytics/tasks-summary/'+postfix, params);
    }

    static getUsers(params: any) {
        return new Request(this,'POST','analytics/communication/flow/users', params);
    }

    static getProcessFlows(params: any) {
        return new Request(this,'POST','analytics/communication/flow/user', params);
    }

    static getUsersCommunications(params: any, postfix: string) {
        return new Request(this,'POST','analytics/communication-communication/'+postfix, params);
    }

    static getUsersCollaborations(params: any) {
        return new Request(this,'POST','analytics/communication-collaboration/user', params);
    }

    static getEffortsDistributionByUser(params: any) {
        return new Request(this,'POST','analytics/time-efforts/efforts/user', params);
    }

    static getEffortsDistributionByProject(params: any, postfix: string) {
        return new Request(this,'POST','analytics/time-efforts/efforts/'+postfix, params);
    }

    static getTimeReporting(params: any, postfix: string) {
        return new Request(this,'POST','analytics/reporting/'+postfix, params);
    }

    static getSelfOrganization(params: any, postfix: string) {
        return new Request(this,'POST','analytics/self-organization/'+postfix, params);
    }

    static getSelfPlanning(params: any, postfix: string) {
        return new Request(this,'POST','analytics/self-planning/'+postfix, params);
    }

    static getAvgResponseTime(params: any, postfix: string) {
        return new Request(this,'POST','analytics/agility/'+postfix, params);
    }

};
